// NotificationAutoAsk.jsx
import React, { useEffect, useState } from "react";

export default function NotificationAutoAsk() {
  const [showBanner, setShowBanner] = useState(false);
  const [perm, setPerm] = useState(
    typeof Notification !== "undefined" ? Notification.permission : "denied"
  );

  useEffect(() => {
    if (!("Notification" in window)) return;

    // 이미 허용/거부면 배너 불필요
    if (Notification.permission === "granted" || Notification.permission === "denied") return;

    // 권한 상태가 'default'라면: 첫 사용자 제스처 때 자동 요청
    const ask = async () => {
      try {
        const result = await Notification.requestPermission();
        setPerm(result);
        setShowBanner(result !== "granted"); // 허용 안 했으면 배너 남김
      } catch (_) {
        setShowBanner(true);
      } finally {
        // 한 번만
        window.removeEventListener("pointerdown", ask, true);
        window.removeEventListener("keydown", ask, true);
        window.removeEventListener("touchstart", ask, true);
      }
    };

    // 첫 상호작용을 잡아 자동 요청
    window.addEventListener("pointerdown", ask, true);
    window.addEventListener("keydown", ask, true);
    window.addEventListener("touchstart", ask, true);

    // 진입 즉시 안내 배너도 보여줌(사용자에게 힌트)
    setShowBanner(true);

    return () => {
      window.removeEventListener("pointerdown", ask, true);
      window.removeEventListener("keydown", ask, true);
      window.removeEventListener("touchstart", ask, true);
    };
  }, []);

  // 이미 허용/거부면 아무것도 렌더 안 함
  if (!("Notification" in window)) return null;
  if (perm === "granted" || perm === "denied") return null;
  if (!showBanner) return null;

  const clickAsk = async () => {
    try {
      const r = await Notification.requestPermission();
      setPerm(r);
      if (r === "granted") setShowBanner(false);
    } catch (_) {}
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: "auto 0 0 0",
        padding: "12px 16px",
        background: "rgba(20,20,20,0.9)",
        color: "white",
        display: "flex",
        gap: 12,
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <span>실시간 알림을 받으시겠어요? (최초 1회 허용 필요)</span>
      <button
        onClick={clickAsk}
        style={{
          background: "white",
          color: "black",
          border: "none",
          borderRadius: 8,
          padding: "6px 12px",
          cursor: "pointer",
        }}
      >
        알림 허용
      </button>
      <button
        onClick={() => setShowBanner(false)}
        style={{
          background: "transparent",
          color: "#ddd",
          border: "1px solid #666",
          borderRadius: 8,
          padding: "6px 10px",
          cursor: "pointer",
          marginLeft: "auto",
        }}
      >
        나중에
      </button>
    </div>
  );
}
